// ============================================================================
// PRICING TRUST (backend copy)
// ----------------------------------------------------------------------------
// The rule for which price-list rows may price a quote line. The frontend's
// src/services/pricing-trust.js is the source; this copy exists because the
// backend image never contains src/ (CLAUDE.md, backend route Rule 4).
// src/__tests__/pricing-trust-backend-parity.test.js fails if the two drift.
//
// Used by the sell-only Pricing projection (routes/misc-routes.js), which
// otherwise strips the provenance fields this rule reads.
// ============================================================================

export function isHiddenPricingItem(item) {
    const status = String(item?.review_status ?? item?.reviewStatus ?? '').trim().toLowerCase();
    const source = String(item?.source ?? item?.origin ?? '').trim().toLowerCase();
    return status === 'pending_review'
        || status === 'formula_component'
        || status === 'retired'
        || item?.selectable_for_scope === false
        || item?.selectableForScope === false
        || source === 'ai_discovered';
}

export function isPendingReviewPricingItem(item) {
    const source = String(item?.source ?? item?.origin ?? '').trim().toLowerCase();
    const sourceRating = String(item?.source_rating ?? item?.sourceRating ?? '').trim().toLowerCase();
    const sourceNote = String(item?.source_note ?? item?.sourceNote ?? '').trim().toLowerCase();
    return isHiddenPricingItem(item)
        || source === 'ai review'
        || sourceRating === 'estimate'
        || sourceNote === 'ai review';
}

export function isTrustedPricingItem(item) {
    return !!item && !isPendingReviewPricingItem(item);
}
